module.exports = __webpack_public_path__ + "img/qian_box_bg_zhCn.4273922e.png";